import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

const LOGO_URL = "/images/singleseen_logo_transparent.png";

const PaymentCancel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50 via-white to-amber-50/30 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center border border-rose-100" data-testid="payment-cancel-card">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <img src={LOGO_URL} alt="SingleSeen" className="h-24 w-auto" />
        </div>

        <div className="w-20 h-20 rounded-full bg-rose-100 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-rose-500" />
        </div>

        <h1 className="font-serif text-2xl text-rose-900 mb-2" data-testid="cancel-heading">{t('payment.cancelTitle')}</h1>
        <p className="text-rose-600 mb-8">
          {t('payment.cancelDesc')}
        </p>

        <div className="space-y-3">
          <Button
            onClick={() => navigate("/pricing")}
            className="w-full bg-gradient-to-r from-rose-500 to-pink-500 text-white hover:from-rose-600 hover:to-pink-600 rounded-full h-12"
            data-testid="back-to-pricing-btn"
          >
            {t('common.backToPricing')}
          </Button>
          <Button
            onClick={() => navigate("/dashboard")}
            variant="outline"
            className="w-full border-rose-300 text-rose-700 hover:bg-rose-50 rounded-full h-12"
            data-testid="go-to-dashboard-btn"
          >
            {t('common.goToDashboard')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
